<mat-card class="forgotPasswordCard">
    <mat-card-header>
        <mat-card-title class="text-uppercase text-left login-header forgotPasswordModalHeader">Forgot Password</mat-card-title>
    </mat-card-header>
    <mat-card-content mat-dialog-content class="position-relative align-content-between">
        <p>Enter your email address that is associated with this account. If you do not remember your email address or you believe that we may have the wrong email address, please call us at 801-365-5000.</p>
        <div class="row">
            <div class="col d-flex mx-auto fit-width">
                <mat-form-field class="col">
                    <mat-label class="text-uppercase">Email Address</mat-label>
                    <input class="emailInput" matInput [(ngModel)]="email" email required placeholder="Example@example.com">
                </mat-form-field>
            </div>
        </div>
        <mat-dialog-actions>
            <div class="text-center w-100">
                <button mat-raised-button class="btn-primary requestBtn" type="submit" color="primary" [mat-dialog-close]="true" (click)="requestPassword()" [disabled]="!email">Request</button>
                <button mat-raised-button [mat-dialog-close]="true" class="btn cancelBtn">Cancel</button>
            </div>
        </mat-dialog-actions>
    </mat-card-content>
</mat-card>
